import { render, staticRenderFns } from "./UserNews.vue?vue&type=template&id=45fa9938&scoped=true&"
import script from "./UserNews.vue?vue&type=script&lang=ts&"
export * from "./UserNews.vue?vue&type=script&lang=ts&"
import style0 from "./UserNews.vue?vue&type=style&index=0&id=45fa9938&lang=less&scoped=true&"
import style1 from "./UserNews.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa9938",
  null
  
)

export default component.exports